// extracted by mini-css-extract-plugin
export default {"customTable":"CustomTable_customTable__Ze7LR","verticalLine":"CustomTable_verticalLine__54fFs"};